module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vregi12-4575afe0aaddfdafa6c0a796f4785066.jpg";